import React, {
  useState,
  useEffect,
} from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import { UserService } from '@pingum/api-services';
import {
  getTenantUsers,
  getTenantCard,
  getTenantInvoices,
  getTenantUpcomingInvoice,
} from '@pingum/app-state-management/tenant/actions';
import {
  Tabs,
  Tab,
} from '@material-ui/core';

import {
  getTenantFromUrl,
  getQueryParam,
  setQueryParam,
} from '../../../utils/urlHelper';
import { isUserOwner } from '../../../utils/tenantAuthenticationHelper';

import Page from '../../widgets/Page';
import SubscriptionCard from './components/SubscriptionCard';
import PaymentMethodCard from './components/PaymentMethodCard';
import InvoicesCard from './components/InvoicesCard';

const SUBSCRIPTION_VIEW = 'subscription';
const PAYMENT_VIEW = 'payment';
const INVOICES_VIEW = 'invoices';

export const TenantBillingComponent = () => {
  const tenantName = getTenantFromUrl();
  const dispatch = useDispatch();

  // grab redux state
  const {
    isFetchingTenant: isFetching,
    tenant,
    tenantUsers,
    stripeCard,
    stripeInvoices,
    stripeUpcomingInvoice,
  } = useSelector((state) => state.tenant);
  const { user: profile } = useSelector((state) => state.user);

  // get user roles
  const roles = UserService.getUserRolesForTenant(
    profile,
    getTenantFromUrl(),
  );
  const userIsOwner = isUserOwner(roles);

  // setup local state
  const [selectedView, setSelectedView]
    = useState(getQueryParam('view')
      ? getQueryParam('view', 10)
      : SUBSCRIPTION_VIEW);

  // do this on component mount
  useEffect(() => {
    dispatch(getTenantUsers(tenantName));
  }, []);
  // do this when the tenant changes
  useEffect(() => {
    if (tenant.stripeCardId && tenant.stripeCardId !== 'card') {
      dispatch(getTenantCard(tenantName, tenant.stripeCardId));
    }
  }, [tenant.stripeCardId]);

  const handleChangeTab = (event, value) => {
    setSelectedView(value);
    setQueryParam('view', value);
    // load invoices only when going to that view
    if (value === INVOICES_VIEW) {
      dispatch(getTenantInvoices(tenantName));
      dispatch(getTenantUpcomingInvoice(tenantName));
    }
  };

  const getTabContent = (tab, isOwner) => {
    switch (tab) {
      case PAYMENT_VIEW:
        return isOwner
          ? (
            <PaymentMethodCard
              tenant={tenant}
              stripeCard={stripeCard}
            />
          )
          : <div>You should not be here</div>;
      case INVOICES_VIEW:
        return isOwner
          ? (
            <InvoicesCard
              tenant={tenant}
              invoices={stripeInvoices}
              upcomingInvoice={stripeUpcomingInvoice}
            />
          )
          : <div>You should not be here</div>;
      case SUBSCRIPTION_VIEW:
      default:
        return isOwner
          ? (
            <SubscriptionCard
              tenant={tenant}
              tenantUsers={tenantUsers}
              stripeCard={stripeCard}
            />
          )
          : <div>You should not be here</div>;
    }
  };

  const tabs = (
    <Tabs
      value={selectedView}
      onChange={handleChangeTab}
      indicatorColor="secondary"
      textColor="inherit"
      variant="scrollable"
      scrollButtons="on"
    >
      {
        userIsOwner
          && (
            <Tab
              label="Subscription"
              value={SUBSCRIPTION_VIEW}
            />
          )
      }
      {
        userIsOwner
          && (
            <Tab
              label="Payment Method"
              value={PAYMENT_VIEW}
            />
          )
      }
      {
        userIsOwner
          && (
            <Tab
              label="Invoices"
              value={INVOICES_VIEW}
            />
          )
      }
    </Tabs>
  );

  return (
    <Page
      title="Billing"
      disableToolbarPadding
      showLoadingIndicator={isFetching}
      toolbar={
        !isFetching
          && tabs
      }
    >
      {getTabContent(selectedView, isUserOwner(roles))}
    </Page>
  );
};

TenantBillingComponent.propTypes = { };
TenantBillingComponent.defaultProps = { };

export default (TenantBillingComponent);
